import { createSlice } from '@reduxjs/toolkit'

export const linkedinSlice = createSlice({
  name: 'linkedin',
  initialState: {
    code: {},
  },
  reducers: {
    updateLinkedinLogin: (state, newValue) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes.
      // Also, no return statement is required from these functions.
      state.code = newValue.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { updateLinkedinLogin } = linkedinSlice.actions;

export const selectLinkedin = (state) => state.linkedin.code;

export default linkedinSlice.reducer